import { getUserInfoApi } from '@/services/http/user';
import { IAccountStorageState } from '@/types/user.types';
import { useRequest } from 'ahooks';
import { createGlobalStore } from 'hox';
import { useState } from 'react';

export const [useAccounterStore] = createGlobalStore(() => {
  const [accounter, setAccounter] = useState<IAccountStorageState | null>(null);
  const [menuPermissionList, setMenuPermissionList] = useState<string[]>([]);
  const isSuperAdmin = accounter?.userName === 'superAdmin';
  const getUserInfoRequest = useRequest(getUserInfoApi, {
    manual: true,
    onSuccess(res) {
      const { userId, userName, menClaimModels } = res.data;
      setAccounter({
        userId,
        userName,
      });
      if (Array.isArray(menClaimModels)) {
        const list = menClaimModels.map((item) => item.menName.toUpperCase());
        setMenuPermissionList(list);
      } else {
        setMenuPermissionList([]);
      }
    },
  });
  return {
    accounter,
    setAccounter,
    getUserInfoRequest,
    menuPermissionList,
    isSuperAdmin,
  };
});
